// Copyright (C) 2026 FlexiProof. All rights reserved.
//
// This source code file is a part of free software licensed under the terms of
// the MIT License as published by the Massachusetts Institute of Technology:
// you can use, copy, modify and distribute any part of it without limitation,
// subject to the conditions contained within that license.
//
// This source code file, and the software it forms a part of, IS PROVIDED "AS
// IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED. See the MIT License
// for more details.
//
// You should have received a copy of the MIT License along with this source
// code file in the root of this repository. If not, see one of the following
// 3rd party sites for a copy of the license template:
// - <https://opensource.org/licenses/MIT>
// - <https://choosealicense.com/licenses/mit>
// - <https://spdx.org/licenses/MIT>

/**
 * @file Type definition for calculator bom.
 * @author James Reid
 */

// @ts-check

// @@imports-package
/* eslint-disable no-unused-vars -- Type imports. */
import { Product } from "../products/index.js"
/* eslint-enable no-unused-vars -- Close disable-enable pair. */

// @@body
/**
 * Line item object including a reference to product object and calculated
 * properties.
 * @typedef {object} LineItem
 * @property {string} uuid Product UUID in database.
 * @property {string} sku Merchant SKU code (defaults to base product SKU).
 * @property {string} code Product calculator code (merchant agnostic).
 * @property {number} quantity Line item quantity of product in bom.
 * @property {Product} product Reference to product object.
 * @property {number} price Total line price.
 * @property {number} vatPrice Total line price including VAT.
 * @property {object} [detail] Optional line details, for instance for feature
 * locations (membrane zones, drain placement etc.).
 */

/**
 * Raw line item object including *only* fields required for adding to basket
 * and saving quote.
 * @typedef {object} RawLineItem
 * @property {string} uuid Product UUID in database.
 * @property {string} sku Merchant SKU code (defaults to base product SKU).
 * @property {number} quantity  Line item quantity of product in bom.
 * @property {number} retailPrice Unit retail price.
 * @property {object} [detail] Optional line details, for instance for feature
 * locations (membrane zones, drain placement etc.).
 */

// @@exports
/**
 * @type {LineItem}
 * @ignore
 */
export let LineItem

/**
 * @type {RawLineItem}
 * @ignore
 */
export let RawLineItem
